import type {SingleComponentPluginFunction} from '../../types'
import type {InnerElementContext} from './types'
import {traverseForUnpack} from './traverse'
import {unpackComponentData, unpackInnerElementData} from './transformations/nesting'
import {unpackInnerElementQueries} from './transformations/queryToNamespace'

/**
 * Combined innerElement transformation for unpack
 * First renames namespace properties back to query, then restores nested data
 */
const unpackInnerElement = (ctx: InnerElementContext): void => {
    unpackInnerElementQueries(ctx)
    unpackInnerElementData(ctx)
}

/**
 * Unpack function that orchestrates all beautifier transformations
 * Traverses the component once in reverse order and applies all transformations efficiently
 */
export const unpack: SingleComponentPluginFunction = (component): void => {
    traverseForUnpack(component, {
        onComponent: unpackComponentData,
        onInnerElement: unpackInnerElement
    })
}
